import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import haatzaFavicon from "./assets/Images/haatzalogo.png";



// Dynamically set favicon from imported asset
const setFavicon = () => {
  let link = document.querySelector("link[rel~='icon']");
  if (!link) {
    link = document.createElement('link');
    link.rel = 'icon';
    document.head.appendChild(link);
  }
  link.href = haatzaFavicon;
  link.type = 'image/png';

  let appleLink = document.querySelector("link[rel='apple-touch-icon']");
  if (!appleLink) {
    appleLink = document.createElement('link');
    appleLink.rel = 'apple-touch-icon';
    document.head.appendChild(appleLink);
  }
  appleLink.href = haatzaFavicon;
};
setFavicon();

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
